// external library
import { jwtDecode } from 'jwt-decode'
import moment from 'moment'

// enums
import EAccessTokenStates from '@/ts/enums/EAccessTokenStates'
import ECookies from '@/ts/enums/ECookies'
import EPortalName from '@/ts/enums/EPortalName'

function getJWTTokenState({ token = useCookie(ECookies.TOKEN), routePath = '' }): EAccessTokenStates {
    const runtimeConfig = useRuntimeConfig()
    if (!token?.value || !useCookie(ECookies.USER_ID)?.value) {
        return EAccessTokenStates.FETCH_TOKEN
    }

    const decoded = jwtDecode(token.value || '') as {
        exp: number
        refresh_expiration_www: number
        expires_in: number
        applicationTypeWww: string
    }

    const expiration_token_date = decoded?.exp
    const expiration_refresh_token_date = decoded?.refresh_expiration_www
    const applicationTypeWww = decoded?.applicationTypeWww

    const isEUmowaPageAndIsOOnlineContractAuthenticationCompoment =
        ['/e-umowa'].includes(routePath) &&
        useCookie(ECookies.EUMOWA_COMPONENT).value === 'OOnlineContractAuthentication' &&
        moment().isSameOrAfter(moment.unix(expiration_refresh_token_date))

    const tokenNeedToBeNew = isEUmowaPageAndIsOOnlineContractAuthenticationCompoment

    if (tokenNeedToBeNew || !expiration_token_date || !expiration_refresh_token_date) {
        return EAccessTokenStates.FETCH_TOKEN
    }

    if (moment().isSameOrAfter(moment.unix(expiration_refresh_token_date))) {
        return EAccessTokenStates.SESSION_EXPIRED
    }

    const secondsToExpireToken = moment.unix(expiration_token_date).diff(moment(), 'seconds')

    if (moment().isSameOrAfter(moment().add(secondsToExpireToken / 2, 's'))) {
        return EAccessTokenStates.NEED_REFRESH
    }

    const PORTAL_NAME = runtimeConfig.public.portalName?.toString()
    if (PORTAL_NAME !== EPortalName.LOCALHOST && applicationTypeWww !== PORTAL_NAME) {
        return EAccessTokenStates.OTHER_APPLICATION_CONTEXT
    }
    return EAccessTokenStates.VALID
}

export default getJWTTokenState
